const EXECUTION_ID = ":executionId";
const ROLE_ID = ":roleId";
const SCENARIO_ID = ":scenarioId";

// Structure:
// 'Route' -> Used in <Route>, always a string to prevent confusion with Navigate
// 'Navigate' -> Used in <Navigate> or navigate(), always a function to prevent confusion with Route
// 'Redirect' -> Used in <Route> with <Navigate> to create a fallback route, always a string

export const Routing = {
    Root: {
        Route: "/*",
        Navigate: (): string => "/"
    },
    Administration: {
        Route: "/administration/*",
        Navigate: (): string => "/administration",
        Redirect: "/*",
        Execution: {
            Route: "/execution",
            Navigate: (): string => "/administration/execution",
            Redirect: "/execution/*",
            Edit: {
                Route: `/execution/${EXECUTION_ID}`,
                Navigate: (executionId: string): string => `/administration/execution/${executionId}`
            },
        },
        Role: {
            Route: "/role",
            Navigate: (): string => "/administration/role",
            Redirect: "/role/*",
            Create: {
                Route: "/role/create",
                Navigate: (): string => "/administration/role/create"
            },
            Edit: {
                Route: `/role/${ROLE_ID}`,
                Navigate: (roleId: string): string => `/administration/role/${roleId}`
            },
        },
        Scenario: {
            Route: "/scenario",
            Navigate: (): string => "/administration/scenario",
            Redirect: "/scenario/*",
            Create: {
                Route: "/scenario/create",
                Navigate: (): string => "/administration/scenario/create"
            },
            Edit: {
                Route: `/scenario/${SCENARIO_ID}`,
                Navigate: (scenarioId: string): string => `/administration/scenario/${scenarioId}`
            },
        },
        Worker: {
            Route: "/worker",
            Navigate: (): string => "/administration/worker",
            Redirect: "/worker/*"
        }
    }
};
